import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HostnameContainerModel } from '../../../../../../models/aggregates/hostname';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';


@Injectable({
  providedIn: 'root'
})
export class HostnamesService extends BaseApiTemplateService<HostnameContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'hostnames/sysadmin-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'hostnames/sysadmin-ep';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'hostnames/sysadmin-ep';
    this.httpClient = http;
  }
}
